import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../lib/firebase'; // Adjust the path as needed
import AllUsers from '../NavPages/AllUsers';
import AddTransaction from '../NavPages/AddTransaction';
import Settings from '../NavPages/Settings';
import Dashboard from '../NavPages/Dashboard';
import UserDetail from '../NavPages/UserDetail';
import TransactionLogs from '../NavPages/TransactionLogs'; // Import TransactionLogs
import Kyc from '../NavPages/Kyc';
import NotFound from '../NavPages/NotFound';
import NotAdmin from './NotAdmin';
import Download from '../Navigation/Download';
import Hamburger from '../Navigation/Hamburger';
import { doc, getDoc } from 'firebase/firestore';
import { dummy } from '../assets';
import './GetDash.css';

const GetDash = ({ toggleSidebar, isSidebarOpen }) => {
    const [user] = useAuthState(auth);
    const [profileData, setProfileData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            const fetchProfileData = async () => {
                try {
                    const docRef = doc(db, 'users', user.uid);
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setProfileData(data);

                        // Redirect if the user is not an admin
                        if (data.role !== 'admin') {
                            navigate('/logout'); // Redirect to the logout route
                        }
                    } else {
                        console.log('No such document!');
                    }
                } catch (error) {
                    console.error('Error fetching profile data:', error);
                }
            };

            fetchProfileData();
        }
    }, [user, navigate]);

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    return (
        <div className="dashboard">
            {user && profileData && (
                <div className="user-info-container">
                    <Link to={`/users/${user.uid}`} className='myLink'>
                        <img
                            src={profileData.profilePictureUrl ? profileData.profilePictureUrl : dummy}
                            alt="User"
                            className="user-img"
                        />
                    </Link>
                    <Link to={`/users/${user.uid}`} className='myLink'>
                        <div className="user-name">{profileData.fullName}</div>
                    </Link>

                    <Hamburger toggleSidebar={toggleSidebar} />
                </div>
            )}

            <div className='contents'>
                <Routes>
                    <Route path="/" element={<Dashboard userId={user.uid} />} />
                    <Route path="/users" element={<AllUsers />} />
                    <Route path="/download" element={<Download />} />
                    <Route path="/users/:userId" element={<UserDetail />} />
                    <Route path="/add-transaction" element={<AddTransaction />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/user/:userId/transactions" element={<TransactionLogs userId={user.uid} />} />
                    <Route path="/kyc/:userId" element={<Kyc
                        userName={profileData.fullName}
                        profilePictureUrl={profileData.profilePictureUrl}
                    />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/logout" element={<NotAdmin
                        userName={profileData.fullName}
                        profilePictureUrl={profileData.profilePictureUrl}
                    />} />
                </Routes>
            </div>
        </div>
    );
};

export default GetDash;
